<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <!-- <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.cu_name}}</em>
          </div>
        </div> -->
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单位</label>
            <span class="weui-form-preview__value">{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">仓库</label>
            <span class="weui-form-preview__value">{{initData.wh_description}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库数量</label>
            <span class="weui-form-preview__value">{{initData.pd_inqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">入库金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_intotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出库数量</label>
            <span class="weui-form-preview__value">{{initData.pd_outqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">出库金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pd_outtotal}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结存数量</label>
            <span class="weui-form-preview__value">{{initData.pwm_endqty}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">结存金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.pwm_endamount}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initData: Object
  }
};
</script>